import Highcharts from "highcharts";
import "highcharts/highcharts-more";
import "highcharts/modules/exporting";
import "highcharts/modules/offline-exporting";

import { PRIMARY_COLORS, TEXT_COLORS } from "@monthly/theme";

// Set number formatting globally: commas for thousands, period for decimals
Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
    decimalPoint: ".",
  },
  chart: {
    style: {
      fontFamily: '"Open Sans", sans-serif',
    },
    backgroundColor: "transparent",
  },
  colors: [
    PRIMARY_COLORS.main,
    "#22C55E", // Success green
    "#F59E0B", // Warning yellow
    "#EF4444", // Error red
    "#8B5CF6", // Purple
    "#06B6D4", // Cyan
  ],
  title: {
    style: {
      fontFamily: '"Titillium Web", sans-serif',
      fontSize: "16px",
      fontWeight: "600",
      color: PRIMARY_COLORS.main,
    },
  },
  subtitle: {
    style: {
      fontFamily: '"Open Sans", sans-serif',
      fontSize: "12px",
      color: TEXT_COLORS.secondary,
    },
  },
  xAxis: {
    labels: {
      useHTML: true,
      formatter: function () {
        const label = String(this.value);
        const maxLength = 15;

        // If label is short enough, return as-is
        if (label.length <= maxLength) {
          return label;
        }

        // Split long labels into multiple lines
        const words = label.split(" ");
        const lines: string[] = [];
        let currentLine = "";

        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;

          if (testLine.length <= maxLength) {
            currentLine = testLine;
          } else {
            if (currentLine) {
              lines.push(currentLine);
            }
            currentLine = word;
          }
        }

        if (currentLine) {
          lines.push(currentLine);
        }

        return lines.join("<br/>");
      },
      style: {
        fontFamily: '"Open Sans", sans-serif',
        fontSize: "11px",
        color: TEXT_COLORS.secondary,
      },
    },
    lineColor: TEXT_COLORS.disabled,
    tickColor: TEXT_COLORS.disabled,
  },
  yAxis: {
    labels: {
      style: {
        fontFamily: '"Open Sans", sans-serif',
        fontSize: "11px",
        color: TEXT_COLORS.secondary,
      },
    },
    gridLineColor: TEXT_COLORS.disabled,
    lineColor: TEXT_COLORS.disabled,
  },
  legend: {
    itemStyle: {
      fontFamily: '"Open Sans", sans-serif',
      fontSize: "12px",
      color: TEXT_COLORS.secondary,
      fontWeight: "400",
    },
    itemHoverStyle: {
      color: PRIMARY_COLORS.main,
    },
  },
  tooltip: {
    backgroundColor: "white",
    borderColor: TEXT_COLORS.disabled,
    borderRadius: 8,
    style: {
      fontFamily: '"Open Sans", sans-serif',
      fontSize: "12px",
      color: TEXT_COLORS.primary,
    },
    shadow: {
      color: "rgba(0, 0, 0, 0.1)",
      offsetX: 0,
      offsetY: 4,
      opacity: 0.2,
      width: 8,
    },
    valueDecimals: 1,
  },
  exporting: {
    enabled: false, // Disable hamburger menu
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    series: {
      animation: {
        duration: 800,
      },
    },
    column: {
      borderRadius: 4,
      borderWidth: 0,
    },
    bar: {
      borderRadius: 4,
      borderWidth: 0,
    },
  },
});

export default Highcharts;
